import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=4b37b879&scoped=true&"
import script from "./menu.vue?vue&type=script&lang=js&"
export * from "./menu.vue?vue&type=script&lang=js&"
import style0 from "./menu.vue?vue&type=style&index=0&id=4b37b879&prod&lang=scss&"
import style1 from "./menu.vue?vue&type=style&index=1&id=4b37b879&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b37b879",
  null
  
)

export default component.exports